import { BookmarkItem } from '@/app/shared/models';
import * as BookmarkTrackingApi from '@/app/bookmark/tracking/api'
import { createQuery, TrackingService2 } from '@/app/tracking/api'
import { getTocItemBySectionId } from '@/app/aspect/toc-utils';


export async function queryBookmarkItem(trackingService: TrackingService2): Promise<BookmarkItem|null> {
  const query = createQuery<BookmarkTrackingApi.QueryBookmarkTrackingQuery>('query-bookmark', {})
  const result = await trackingService.query(query)

  const sectionId: string = result.bookmark.sectionId;
  return getTocItemBySectionId(sectionId);
}